export const FILTER_PROJECT_STATE = 'ps'
export const FILTER_TREND_RADAR = 'tr'
export const FILTER_INNOVATION_FIELD = 'if'

export const initFilter = () => ({
    [FILTER_PROJECT_STATE]: null,
    [FILTER_TREND_RADAR]: null,
    [FILTER_INNOVATION_FIELD]: null
})
